import * as tslib_1 from "tslib";
import * as React from 'react';
import Styles from "./CreateNewFilterButton.css";

var CreateNewFilterButton = function CreateNewFilterButton(props) {
  return React.createElement("div", tslib_1.__assign({
    "data-test": "create-new-button",
    className: Styles.createNewFilterButton
  }, props), "+ Create new filter");
};

export default CreateNewFilterButton;